export default __webpack_public_path__ + "static/media/HamMenu.2c3f2847.svg";